import { useEffect, useLayoutEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SmallLogo from "../../assets/images/logos/small-logo.webp";
import TitleImage from "../../assets/images/webp/hembergurmenu.webp";
import DiscordIcon from "../../assets/images/social/discord.webp";
import TwitterIcon from "../../assets/images/social/twitter.webp";
import YoutubeIcon from "../../assets/images/social/youtube.webp";
import MediumIcon from "../../assets/images/social/medium.webp";
import DiscordSelectedIcon from "../../assets/images/social/discord-selected.webp";
import TwitterSelectedIcon from "../../assets/images/social/twitter-selected.webp";
import YoutubeSelectedIcon from "../../assets/images/social/youtube-selected.webp";
import MediumSelectedIcon from "../../assets/images/social/medium-selected.webp";
import enImage from "../../assets/images/lang/en.png";
import ptImage from "../../assets/images/lang/pt.png";
import dfwImage from "../../assets/images/webp/download.webp";
import dfwsImage from "../../assets/images/webp/download-selected.webp";
import dfwPtImage from "../../assets/images/webp/download-pt.webp";
import dfwsPtImage from "../../assets/images/webp/download-select-pt.webp";
import NavClose from "../../assets/images/webp/nav_close.webp";
import lockGlow from "../../assets/images/webp/lock-glow.webp";
import titleline from "../../assets/images/webp/title_line.webp";


function Index({ type = "" }) {
  const [show, setShow] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const { i18n, t } = useTranslation();
  const currentLang = localStorage.getItem("language");

  //    useEffect(() => {
  //    fetch('https://ipapi.co/json/')
  //    .then( res => res.json())
  //    .then(response => {
  //     console.log("Country is : ", response);
  //   })
  //   .catch((data, status) => {
  //     console.log('Request failed:', data);
  //   });
  // },[])

  useEffect(() => {
    if (currentLang) {
      i18n.changeLanguage(currentLang);
    }
  }, [currentLang]);

  const handleLangChange = (lang) => {
    localStorage.setItem("language", lang);
    i18n.changeLanguage(lang);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document?.documentElement?.scrollTo({ top: 0, behavior: "smooth" });
    }, [location?.pathname]);
    return children;
  };

  const GameInfoMenu = () => {
    return (
      <div className="border-inner">
                              <div className="position-absolute top-left-box" />
                              <div className="position-absolute top-right-box" />
                              <div className="position-absolute bottom-left-box" />
                              <div className="position-absolute bottom-right-box" />
                              <Dropdown.Item
                                href="/#warriors"
                                onClick={(event) => {
                                  handleClose();
                                  setTimeout(() => {
                                    event.preventDefault();
                                    window.location.href = "/#warriors";
                                  }, 500);
                                }}
                              >
                                {t("The Warrior")}
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="/#team-moba"
                                onClick={(event) => {
                                  handleClose();
                                  setTimeout(() => {
                                    event.preventDefault();
                                    window.location.href = "/#team-moba";
                                  }, 500);
                                }}
                              >
                                {t("Team-based Deathmatch")}
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="/#flagship-game"
                                onClick={(event) => {
                                  handleClose();
                                  setTimeout(() => {
                                    event.preventDefault();
                                    window.location.href = "/#flagship-game";
                                  }, 500);
                                }}
                              >
                                {t("Mercenaries Game Mode")}
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="/#roadmap"
                                onClick={(event) => {
                                  handleClose();
                                  setTimeout(() => {
                                    event.preventDefault();
                                    window.location.href = "/#roadmap";
                                  }, 500);
                                }}
                              >
                                {t("Roadmap")}
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="/#partners"
                                onClick={(event) => {
                                  handleClose();
                                  setTimeout(() => {
                                    event.preventDefault();
                                    window.location.href = "/#partners";
                                  }, 500);
                                }}
                              >
                                {t("Partners")}
                              </Dropdown.Item>
                            </div>
  )
  }

  const SocialMedia = () => {
    return (
       <div className="border-inner">
                            <div className="position-absolute top-left-box" />
                            <div className="position-absolute top-right-box" />
                            <div className="position-absolute bottom-left-box" />
                            <div className="position-absolute bottom-right-box" />
                            <ul className="list-unstyled menu-social-icons d-flex justify-content-around">
                              <li>
                                <a
                                  href={process.env.REACT_APP_DISCORD_LINK}
                                  target={"_blank"}
                                  rel="noreferrer"
                                >
                                  <div className="dfws-card">
                                    <img
                                      className="img-fluid"
                                      src={DiscordIcon}
                                      width={24}
                                      alt={""}
                                    />
                                    <img
                                      className="img-fluid img-top-social"
                                      src={DiscordSelectedIcon}
                                      width={24}
                                      alt={""}
                                    />
                                  </div>
                                </a>
                              </li>
                              <li>
                                <a
                                  href={process.env.REACT_APP_TWITTER_LINK}
                                  target={"_blank"}
                                  rel="noreferrer"
                                >
                                  <div className="dfws-card">
                                    <img
                                      className="img-fluid"
                                      src={TwitterIcon}
                                      width={18}
                                      alt={""}
                                    />
                                    <img
                                      className="img-fluid img-top-social"
                                      // style={{ top: 3 }}
                                      src={TwitterSelectedIcon}
                                      width={18}
                                      alt={""}
                                    />
                                  </div>
                                </a>
                              </li>
                              <li>
                                <a
                                  href={process.env.REACT_APP_YOUTUBE_LINK}
                                  target={"_blank"}
                                  rel="noreferrer"
                                >
                                  <div className="dfws-card">
                                    <img
                                      className="img-fluid"
                                      src={YoutubeIcon}
                                      width={24}
                                      alt={""}
                                    />
                                    <img
                                      className="img-fluid img-top-social"
                                      src={YoutubeSelectedIcon}
                                      width={24}
                                      alt={""}
                                    />
                                  </div>
                                </a>
                              </li>
                              <li>
                                <a
                                  href={process.env.REACT_APP_MEDIUM_LINK}
                                  target={"_blank"}
                                  rel="noreferrer"
                                >
                                  <div className="dfws-card">
                                    <img
                                      className="img-fluid"
                                      src={MediumIcon}
                                      width={24}
                                      alt={""}
                                    />
                                    <img
                                      className="img-fluid img-top-social"
                                      src={MediumSelectedIcon}
                                      width={24}
                                      alt={""}
                                    />
                                  </div>
                                </a>
                              </li>
                            </ul>
                          </div>
    )
  }


  return (
    <Wrapper>
      <header className="header bg-transparent">
        <div className="homepage_BottomFade"></div>
        <nav className="navbar navbar-expand-lg bg-transparent">
          <div className="container-fluid ">
            <button
              className="navbar-toggler"
              type="button"
              onClick={handleShow}
            >
              <img src={TitleImage} className="img-fluid" />
            </button>
            <Link to="/" className="navbar-brand d-none d-lg-block">
              <img src={SmallLogo} className="img-fluid" alt="" />
            </Link>
            <ul className="navbar-nav navbar-nav-right d-lg-none flex-row align-items-center ms-auto">
              <li className="nav-item dropdwon lang-menu">
                <Dropdown>
        <Dropdown.Toggle
          id="gameinfo123"
          className="bg-transparent border-0 nav-link shadow-none nav-link-language d-flex align-items-baseline"
        >
          <img
            src={localStorage.getItem("language") === "PT" ? ptImage : enImage}
            className="img-fluid me-2"
            alt="Discord"
          />
          {localStorage.getItem("language") || "EN"}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <div className="border-inner">
            <div className="position-absolute top-left-box" />
            <div className="position-absolute top-right-box" />
            <div className="position-absolute bottom-left-box" />
            <div className="position-absolute bottom-right-box" />
            <div className="lang-option">
              <Dropdown.Item  className="d-flex align-items-baseline" onClick={() => handleLangChange("EN")}>
                <img src={enImage} className="img-fluid me-2" alt="enImage" />{" "}
                English
              </Dropdown.Item>
              <Dropdown.Item  className="d-flex align-items-baseline"  onClick={() => handleLangChange("PT")}>
                <img src={ptImage} className="img-fluid me-2" alt="ptImage" />{" "}
                Portuguese
              </Dropdown.Item>
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
              </li>
              {/* <li className="nav-item">
              <a className="nav-link " href={"/#signup-link"}>
                <img
                  src={SignupMobileIcon}
                  className="img-fluid"
                  width={32}
                  alt="Twitter"
                />
              </a>
            </li> */}
            </ul>
            <Offcanvas
              show={show}
              onHide={handleClose}
              responsive="lg"
              id="offcanvasResponsive"
              aria-labelledby="offcanvasResponsiveLabel"
            >
              <Offcanvas.Header>
                <button
                  type="button"
                  className="btn-close pt-3 pe-5"
                  onClick={handleClose}
                  aria-label="Close"
                >
                  <img
                    src={NavClose}
                    className=""
                    width={30}
                    height={30}
                    alt=""
                  />
                </button>
                {/* <Link
                  to="/"
                  className="mobile-logo"
                  id="offcanvasWithBothOptionsLabel"
                >
                  <img src={LargeLogo} className="img-fluid" alt="" />
                </Link> */}
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="navbar">

                  
                  <ul className="navbar-nav navbar-nav-menu">
                    {type === "news" ? (
                      <li className="nav-item">
                        <Link
                          to="/"
                          className="nav-link d-flex align-items-center"
                        >
                          {t("Home")}
                        </Link>
                      </li>
                    ) : (
                        <li className="nav-item dropdown">
                          
                          <Dropdown>
 <Dropdown.Toggle
                            id="gameinfo"
                            className="bg-transparent border-0 nav-link shadow-none d-flex align-items-center"
                          >
                            {t("Game Info")}
                          </Dropdown.Toggle>

  <ul className="dropdown-menu dropdown-menu-new">
    <GameInfoMenu />
                            </ul>
                            <Dropdown.Menu className="mobile-menu">
    <GameInfoMenu />

                            </Dropdown.Menu>
</Dropdown>
                      </li>
                    )}
                    {type !== "news" && (
                      <li className="nav-item">
                        <a
                          className="nav-link d-flex align-items-center"
                          href={
                            localStorage.getItem("language") === "PT"
                              ? process.env.REACT_APP_WHITEPAPER_LINK_PT
                              : process.env.REACT_APP_WHITEPAPER_LINK
                          }
                          target="_blank"
                          rel="noreferrer"
                           onClick={(event) => {
                           setShowDropdown(!showDropdown)
                                }}
                        >
                          {t("Whitepaper")}
                        </a>
                      </li>
                    )}
                    <li className="nav-item">
                      <div
                        className="nav-link d-flex align-items-center div-disabled "
                      >
                      <img src={lockGlow} alt="" width={'24'} className="me-2" />  {t("Marketplace")}
                      </div>
                        {/* <a
                        className="nav-link d-flex align-items-center"
                        href={process.env.REACT_APP_MARKETPLACE_LINK}
                        target="_blank"
                        rel="noreferrer"
                         onClick={(event) => {
                           setShowDropdown(!showDropdown)
                                }}
                      >
                        {t("Marketplace")}
                      </a> */}
                        <img src={titleline} alt="" width={'100%'} className="position-absolute" style={{bottom : 12,left:0}} />
                      <span className="badge badge-light supp"> Coming Soon</span>
                    </li>
                    <li className="nav-item dropdown our-social">
                      <Dropdown>
                        <Dropdown.Toggle
                          id="dropdown-basic"
                          className="bg-transparent border-0 nav-link shadow-none d-flex align-items-center"
                        >
                          {t("Our Socials")}
                        </Dropdown.Toggle>
                         <ul className="dropdown-menu  dropdown-menu-new">
                         <SocialMedia />
                        </ul>

                         <Dropdown.Menu className="mobile-menu">
    <SocialMedia />

                            </Dropdown.Menu>


                      </Dropdown>
                    </li>
                    <li
                      className={`nav-item ${type === "news" ? "active" : ""}`}
                    >
                      <Link
                          to="/news"
                          className={`nav-link d-flex align-items-center ${
                            type === "news" ? "active" : ""
                          }`}
                        >
                        {type !== "news"
                          ? `${t("Latest")} ${t("News")}`
                          : t("News")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </Offcanvas.Body>
              <ul className="navbar-nav navbar-nav-right align-items-center me-0 mb-2 mb-lg-0 d-lg-flex d-none mx-auto">
                <li className="nav-item  lang-menu">
                 <Dropdown>
        <Dropdown.Toggle
          id="gameinfo123"
          className="bg-transparent border-0 nav-link shadow-none nav-link-language d-flex align-items-baseline"
        >
          <img
            src={localStorage.getItem("language") === "PT" ? ptImage : enImage}
            className="img-fluid me-2"
            alt="Discord"
          />
          {localStorage.getItem("language") || "EN"}
        </Dropdown.Toggle>

        <ul className="dropdown-menu">
          <div className="border-inner">
            <div className="position-absolute top-left-box" />
            <div className="position-absolute top-right-box" />
            <div className="position-absolute bottom-left-box" />
            <div className="position-absolute bottom-right-box" />
            <div className="lang-option">
              <Dropdown.Item className="d-flex align-items-baseline" onClick={() => handleLangChange("EN")}>
                <img src={enImage} className="img-fluid me-2" alt="enImage" />{" "}
                English
              </Dropdown.Item>
              <Dropdown.Item className="d-flex align-items-baseline" onClick={() => handleLangChange("PT")}>
                <img src={ptImage} className="img-fluid me-2" alt="ptImage" />{" "}
                Portuguese
              </Dropdown.Item>
            </div>
          </div>
        </ul>
      </Dropdown>
                </li>
                {/* <li className="nav-item">
                  <a className="nav-download" href="/#signup-link">
                    <div className="dfws-card">
                      <img
                        className="img-fluid ms-2"
                        src={sImage}
                        width={120}
                        height={50}
                        alt={""}
                      />
                      <img
                        className="img-fluid ms-2 img-top"
                        src={ssImage}
                        width={120}
                        height={50}
                        alt={""}
                      />
                    </div>
                  </a>
                </li> */}
                <li className="nav-item">
                  <a
                    href={process.env.REACT_APP_GAME_DOWNLOAD_LINK}
                    target="_blank"
                    rel="noreferrer"
                    className="nav-download"
                  >
                    {/* <div className="nav-download"> */}

                    <div className="dfws-card">
                      <img
                        className="img-fluid ms-2"
                        src={
                          localStorage.getItem("language") === "PT"
                            ? dfwPtImage
                            : dfwImage
                        }
                        width={180}
                        height={50}
                        alt={""}
                      />
                      <img
                        className="img-fluid ms-2 img-top"
                        src={
                          localStorage.getItem("language") === "PT"
                            ? dfwsPtImage
                            : dfwsImage
                        }
                        width={180}
                        height={50}
                        alt={""}
                      />
                     {/* <img src={titleline} alt="" width={'100%'} className="position-absolute" style={{bottom : -1,left:0}} />
                      <span className="badge badge-light supp" style={{bottom: -24}}> Coming Soon</span> */}
                    </div>
                     
                    </a>
                    {/* </div> */}
                </li>
              </ul>
            </Offcanvas>
          </div>
        </nav>
        <Outlet />
      </header>
    </Wrapper>
  );
}

export default Index;
